import type UserAgentInfo from 'js/lib/useragent';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import inServerContext from 'bundles/ssr/util/inServerContext';

const useMobileScreen = (userAgent: UserAgentInfo) => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  if (inServerContext) {
    return {
      isMobileScreen: userAgent.isMobile || userAgent.isMobileBrowser || userAgent.isMobilePhoneBrowser,
    };
  }

  return {
    isMobileScreen: isMobile,
  };
};

export default useMobileScreen;
